import { render, staticRenderFns } from "./r-list.vue?vue&type=template&id=283704c8"
import script from "./r-list.vue?vue&type=script&lang=js"
export * from "./r-list.vue?vue&type=script&lang=js"
import style0 from "./r-list.vue?vue&type=style&index=0&id=283704c8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports